// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__mcjNw","title":"ClientReferral_title__oyyXc","itemText":"ClientReferral_itemText__3uSjG"};